import axios from 'axios'
import { API } from 'Config'

import { Organization, Project } from 'GraphQL/Main/TypedDocuments'

import { Session } from 'Services/Store/Session'

import { SignFileResponse } from './types'

type ProjectTaskAttachmentParams = {
  type: 'projectTaskAttachment'
  organization_id: Organization['id']
  project_id: Project['id']
}

type SignFileParams = { file: File } & ProjectTaskAttachmentParams

async function signFile({ file, ...rest }: SignFileParams) {
  const accessToken = Session.getAccessToken()
  if (!accessToken) return undefined

  const { data } = await axios({
    baseURL: API.MAIN_URL,
    url: 'v1/file/sign',
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    params: {
      name: file.name,
      size: file.size.toString(),
      content_type: file.type,
      ...rest,
    },
  })
  if (!data?.ok) return undefined

  return {
    ok: true,
    ...data,
  } as SignFileResponse
}

type UploadFileParams = { file: File; url: string }

async function uploadFile({ file, url }: UploadFileParams) {
  const result = await axios.put(url, file, {
    headers: {
      'Content-Type': file.type,
      'Content-Disposition': `attachment;filename="${unescape(
        encodeURIComponent(file.name),
      )}"`,
    },
  })

  return result.status === 200
}

export { signFile, uploadFile }
